import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";

import { getAuthorizationToken } from "@/auth/tokenStore";

import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import SearchDashboard from "../Components/SearchDashboard/main";
import "../Components/SearchDashboard/SearchLayout.css";
import "../Components/SearchDashboard/SearchResults.css";
import "../Components/SearchDashboard/SearchDashboard.css";
import {
  setSearchText,
  setCurrentSearchStatus,
  setsearchAlphabet,
  searchGlobalOnLogin,
  updateTabName,
  setCurrentTab,
  setLoginSearchText,
  setSearchResult,
  setHasData,
  setTabsResultCount,
  setSearchType,
} from "../Redux/search/searchSlice";
import Footer from "../Components/common/footer";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";

const SearchPage = () => {
  // Redux
  const dispatch = useDispatch();
  const loginSearchText = useSelector((state) => state.searchS.loginSearchText);
  const searchText = useSelector((state) => state.searchS.searchText);
  const searchAlphabet = useSelector((state) => state.searchS.searchAlphabet);
  const currentTab = useSelector((state) => state.searchS.currentTab);
  const origin = process.env.REACT_APP_BACKEND_URL;
  const token1 = getAuthorizationToken();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 24).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  const getLatestSearchOnLogin = async () => {
    if (searchText?.trim() === "") {
      try {
        const response = await axios.get(`${origin}/api/search/latest_search/`, {
          headers: { Authorization: token1 },
        });
        const latest_search = response.data;
        if (latest_search.tab_name === "tabs") {
          dispatch(setsearchAlphabet(false));
          dispatch(setLoginSearchText(response.data.query));
          dispatch(setSearchText(response.data.query));
        } else if (latest_search.tab_name === "alphabets") {
          dispatch(setsearchAlphabet(true));
          dispatch(setLoginSearchText(response.data.query));
          dispatch(setSearchText(response.data.query));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }

      try {
        const response = await axios.get(`${origin}/api/search/latest_search_tab/`, {
          headers: { Authorization: token1 },
        });
        const latest_search_tab = response.data;
        if (latest_search_tab.tab_name) {
          dispatch(setCurrentTab(latest_search_tab.tab_name));
        }
      } catch (error) {
        console.error("Error fetching currentTab:", error);
      }
    }
  };

  const handleBeforeUnload = () => {
    dispatch(setSearchText(""));
    dispatch(setCurrentTab(""));
    dispatch(setSearchResult(""));
    dispatch(setHasData(false));
    dispatch(setCurrentSearchStatus(""));
    dispatch(
      setTabsResultCount({
        invoice: 0,
        incident: 0,
        "incident-date": 0,
        check: 0,
        "client-name": 0,
        "client-email": 0,
        "client-SSN": 0,
        "client-phone": 0,
        "client-birthday": 0,
        defendant: 0,
        "defendant-phone": 0,
        witness: 0,
        claim: 0,
        "court-case": 0,
        otherparty: 0,
        address: 0,
        notes: 0,
        document: 0,
      })
    );
    dispatch(setSearchType(""));
    dispatch(setsearchAlphabet(false));
  };

  useEffect(() => {
    getLatestSearchOnLogin();
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    // sending page ids directly now.
    if (caseId) {
      fetchShakespeareStatus(caseId, 24, dispatch);
    }
  }, [caseId, dispatch]);

  //  Getting the search page on first time login
  useEffect(() => {
    if (loginSearchText !== "") {
      if (searchAlphabet === false) {
        dispatch(
          searchGlobalOnLogin({
            name: loginSearchText,
            tab_name: "tabs",
            token: token1,
          })
        );
      } else {
        dispatch(
          searchGlobalOnLogin({
            name: loginSearchText,
            tab_name: "alphabets",
            token: token1,
          })
        );
      }

      dispatch(setLoginSearchText(""));
    }
  }, [dispatch, loginSearchText, searchAlphabet, token1]);

  //  To set the current tab in the database if the tab changes
  useEffect(() => {
    if (currentTab !== "") {
      dispatch(updateTabName({ tab_name: currentTab }));
    }
  }, [currentTab, dispatch]);

  //

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container " style={{ overflowY: "hidden" }}>
          <NavBar flaggedPageName={"24"} />
          <SearchDashboard pageObj={pageObject} />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SearchPage;
